import { useDispatch } from "react-redux";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import React from "react";
import { deleteCompanyAsyncThunk } from "../../store/company/companySlice";

export default function DeleteDialog({ show, hideDialog, onDeleteCompany, companyId, name }) {
    const dispatch = useDispatch();
    
    const deleteCompany = async () => {
        onDeleteCompany();
        await dispatch(deleteCompanyAsyncThunk(companyId));
    };

    const deleteCompanyDialogFooter = (
        <React.Fragment>
            <Button label="Hayır" icon="pi pi-times" outlined onClick={hideDialog} />
            <Button label="Evet" icon="pi pi-check" severity="danger" onClick={deleteCompany} />
        </React.Fragment>
    );

    return (
        <Dialog visible={show} style={{ width: '32rem' }} breakpoints={{ '960px': '75vw', '641px': '90vw' }} header="Silme" modal footer={deleteCompanyDialogFooter} onHide={hideDialog}>
            <div className="confirmation-content">
                <i className="pi pi-exclamation-triangle mr-3" style={{ fontSize: '2rem' }} />
                <span>
                    <b>{name}</b> Silmek istediğinize emin misiniz ?
                </span>
            </div>
        </Dialog>
    );
}